<template>
    <div>
        <el-form-item label="Tekst"
                      :error="errors[addLanguageSuffix('text')]">
            <el-input type="textarea"
                      v-model="form[addLanguageSuffix('text')]"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TextField.vue?5f916b08